<template>
  <page-resolver v-bind="{ ...$props, ...$attrs }">
    <template v-slot:failed>
      <div />
    </template>
  </page-resolver>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import PageResolver from '@/components/resolvers/PageResolver.vue'
import { resolversBaseProps } from '@/composition/resolvers'

export default defineComponent({
  components: {
    PageResolver,
  },
  props: {
    ...resolversBaseProps,
  },
})
</script>
